import React, { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm.js";
import { loadStripe } from "@stripe/stripe-js";
import Apiauth from "../../API/Apiauth.js";

const StripeCheckout = (props) => {
    const { customer_id, creditCardDetails, setcreditCardDetails, amount, onPaymentSuccess } = props;

    const [clientSecret, setClientSecret] = useState("");

    const stripePromise = loadStripe(creditCardDetails?.key); // Correctly initialize Stripe

    // Function to create the payment intent
    const createPaymentIntent = async (amount) => {
        try {
            if (!clientSecret) {
                let ObjectPost = {
                    amount: amount,
                    slug: creditCardDetails?.payment_slag,
                    PaymentMethod: creditCardDetails?.PaymentMethod,
                    customer_id: customer_id
                };
                let res = await Apiauth(ObjectPost, `pos/PaymentQRcode/getPayment-token`);
                if (res?.code === 200) {
                    setClientSecret(res?.data?.clientSecret);
                    setcreditCardDetails((state) => ({
                        ...state,
                        message: "",
                        payment: false,
                        stripekey: res?.data?.payment_intent_id,
                        client_reference_id: res?.data?.client_reference_id
                    }));
                }
            }
        } catch (err) {
            console.error("Error while creating payment intent:", err);
        }
    };

    useEffect(() => {
        if (customer_id) {
            createPaymentIntent(amount || 5000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customer_id, amount]);

    return (
        <div className="rs">
            {clientSecret ? (
                <Elements
                    options={{
                        clientSecret,
                        appearance: {
                            theme: "stripe",
                            variables: {
                                colorPrimary: '#5CC7C0',
                                fontLineHeight: '17.29px',
                                colorBackground: '#ffffff',
                                colorText: '#717171',
                                fontFamily: 'Segoe UI',
                                fontSizeBase: '14px',
                                colorTextPlaceholder: '#C0C0C0'
                            },
                            rules: {
                                '.Input::placeholder': {
                                    color: '#C0C0C0',
                                    fontFamily: 'Segoe UI',
                                    fontSize: '16px',
                                    lineHeight: '27.69px'
                                },
                                '.Input': {
                                    border: '1px solid #ced4da',
                                    borderRadius: '0.375rem',
                                    marginTop: '8px'
                                },
                                '.Input:focus': {
                                    border: '1px solid #5CC7C0',
                                    boxShadow: 'none'
                                }
                            }
                        }
                    }}
                    stripe={stripePromise}
                >
                    <CheckoutForm
                        onPaymentSuccess={onPaymentSuccess}
                        successMessage="Payment Successful"
                        creditCardDetails={creditCardDetails}
                        setcreditCardDetails={setcreditCardDetails}
                        amount={amount}
                    />
                </Elements>
            ) : (
                <><p> Loading ...</p></>
            )}
        </div>
    );
};

export default StripeCheckout;
